<ng-container *ngIf="documentedResource?.documents as documents; else emptyState">
  <h3 class="mat-h3">{{ header }}</h3>

  <table mat-table [dataSource]="documents" [trackBy]="'uri' | mtnaTrackByProperty">
    <ng-container matColumnDef="document">
      <td mat-cell *matCellDef="let document">
        {{ document.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <td mat-cell *matCellDef="let document">
        {{ document.description }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <td mat-cell *matCellDef="let document">
        <a
          download
          mat-icon-button
          i18n-aria-label
          aria-label="Download document"
          i18n-matTooltip
          matTooltip="Download document"
          matTooltipPosition="before"
          [href]="document | mtnaConsumerToManagerFile | mtnaFileDownloadUrl"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>cloud_download</mat-icon>
        </a>
      </td>
    </ng-container>

    <tr
      *matRowDef="let row; columns: displayedColumns"
      [attr.aria-label]="row.descriptor"
      mat-row
      tabindex="0"
      [class.selected-row]="row.uri === selectedRow"
      (click)="handleSelectRow(row)"
      (keyup.enter)="handleSelectRow(row)"
    ></tr>
  </table>
</ng-container>
<ng-template #emptyState>
  <mtna-empty-state
    i18n-title
    i18n-message
    title="No Documents"
    message="There are currently no additional documents associated with this data product."
  >
  </mtna-empty-state>
</ng-template>
